//import { MultipleColors, SingleColor } from "react-countdown-circle-timer";

export interface QuizInitCountdownEntity {
	Seconds: number;
	Colors: {
		0: `#${string}`;
	} & {
		1: `#${string}`;
	} & `#${string}`[];
	ColorTime: { 0: number } & { 1: number } & number[];
}

export interface QuizConfigurationEntity {
	InitCountdownConfig: QuizInitCountdownEntity;
	PointsCounterDurationInSec: number;
	PointsCounterDelayInSec: number;
	DelayAfterAnswerInMS: number;
	ProgressBarInitialDelayInMS: number; //to make sure the browser sees a delay between width 100% and width 0%
}

export const QuizConfig: QuizConfigurationEntity = {
	InitCountdownConfig: {
		Seconds: 3,
		Colors: ['#E04054', '#44d33f'],
		ColorTime: [5, 0],
	},
	PointsCounterDurationInSec: 0.5,
	PointsCounterDelayInSec: 0,
	DelayAfterAnswerInMS: 1500,
	ProgressBarInitialDelayInMS: 200,
};
